import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

function InputLingoLanguages({ name, data, inputChange }) {
  const { t } = useTranslation();
  const { lingoPlans } = useSelector((state) => state.genericReducer);

  return (
    <div className="input-lingoPlans">
      <label htmlFor={name}>{t("REQUESTED_PLAN")}</label>
      <div className="select-wrapper">
        <select name={name} value={data ? data : ""} onChange={(e) => inputChange(e.target)}>
          <option value={""}> {t("SELECT")}</option>
          {lingoPlans &&
            lingoPlans?.map((option) => (
              <option key={option.id} value={option.id}>
                {" "}
                {option.nameEnglish}{" "}
              </option>
            ))}
        </select>
      </div>
    </div>
  );
}

export default InputLingoLanguages;
